var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSynchronizeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6533 5.16699H11.9932C11.9932 8.01358 9.67371 10.3339 6.82715 10.334C5.4472 10.334 4.14715 9.79357 3.17383 8.82031L3.87988 8.11328C4.66655 8.89995 5.71382 9.33398 6.82715 9.33398C9.12704 9.33386 10.9932 7.46692 10.9932 5.16699H9.33398L11.4932 2.5L13.6533 5.16699ZM6.82715 0C8.20706 6.19697e-05 9.50719 0.540394 10.4805 1.51367L9.77344 2.2207C8.98683 1.43409 7.94039 1.00006 6.82715 1C4.52715 1 2.66016 2.86699 2.66016 5.16699H4.32031L2.16016 7.83398L0 5.16699H1.66016C1.66016 2.32033 3.98048 0 6.82715 0Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSynchronizeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Synchronize_Icon.b8f238449a0fb20d917315f3c7d0a670.svg";